<template>
  <div
    :class="(show ? 'main' : 'disabled') + ' btnBox ' + containerClass"
    :style="downBg()"
  >
    <a
      href="javascript:;"
      class="btn actModules_actionBtn downloadGameBtn"
      @click="downBtn"
      v-if="state === 'undownload'"
    >
      <span class="">{{ buttonName }}</span>
    </a>
    <a
      href="javascript:;"
      class="btn actModules_actionBtn downloadGameBtn"
      @click="downBtn"
      v-else-if="state === 'installed'"
    >
      <span class="">{{ buttonName }}</span>
      <em class="actModules_actionBtnTips">成功下载安装游戏</em>
    </a>
    <a
      href="javascript:;"
      class="actModules_actionBtn downloadGameBtn"
      @click="downBtn"
      v-else-if="state === 'finish'"
    >
      <span>腾讯认证 正版安装</span>
    </a>
    <a
      href="javascript:;"
      class="actModules_actionBtn btn downloadGameBtn"
      @click="downBtn"
      v-else
    >
      <span>{{ buttonName }}{{ downloadProgress }}%</span>
      <div
        class="actModules_DownLoadBar"
        :style="{ width: downloadProgress + '%' }"
      >
        <div class="actModules_DownLoadBarProcess">
          <span>{{ buttonName }}{{ downloadProgress }}%</span>
        </div>
      </div>
      <!-- <span class="actModules_DownLoadBar">
        <span class="actModules_DownLoadPercent">{{downloadProgress}}%</span>
        <i class="actModules_DownLoadBarProcess" :style="{'width': downloadProgress + '%'}"></i>
      </span> -->
    </a>
  </div>
</template>
<script>
import { report } from '../buryingPoint/index';
import bus from '../../../bus';
export default {
	name: 'h5-downBtn',
	actConfig: {
		labels: {
			// 字段名称，用于显示在配置系统上，在正式环境会删除
			modulesTitle: '头部文案：',
			bgImg: '背景图片',
			// gotoAppurl: '拉起超核下载地址',
			tabItems: 'Tab',
			name: '名称',
			image: '图片',
			actionInfo: '下载',
			action: '下载动作',
			h5Action: 'H5动作',
			actionType: '动作类型', // 自定义动作类型，系统内置有 ams: ams动作， link: 跳转到外链
			buttonName: '按钮文案',
			packagename: '包名',
			queryButton: '动作类型',
			type: '是否白名单显示',
			queryType: '白名单显示配置',
		}
	},
	props: {
		buttonName: {
			type: String,
			default: '功能按钮',
			label: '按钮'
		},
		bgImg: {
			type: Object,
			default: function () {
				return {
					class: 'image',
					value: ''
				};
			}
		},
		packagename: {
			type: String,
			default: '',
			label: '包名'
		},
		queryButton: {
			type: Array,
			default: () => [
				{
					h5Action: {
						class: 'action',
						type: 'no',
						value: '', //
						ruleId: ''
					}
				}
			]
		},
		type: {
			type: String,
			default: '0'
		},
		queryType: {
			type: Array,
			default: () => [
				{
					h5Action: {
						class: 'action',
						type: 'no',
						value: '', //
						ruleId: ''
					}
				}
			]
		},
		// gotoAppurl: {
		// 	type: String,
		// 	default: '',
		// 	label: '拉起超核下载地址',
		// },
	},
	data () {
		return {
			gameInfo: {},
			mobileType: 'android',
			downloadProgress: 10,
			state: 'undownload',
			ret: null,
			labelBtn: '下载游戏',
			containerClass:
        this.$actMode === 'development' ? 'btnBoxAbsolute' : 'btnBoxFixed',
			show: true
		};
	},
	mounted () {
		// 获取下载链接
		bus.$on('showNamelist', () => {
			this.queryShow();
		});
		this.getGameInfo();
		window.downloadAppCacheSed = window.downloadAppCacheSed || {};
		this.userAgent();
		if (window.Tgclub) {
			window._ret = '';
			setTimeout(() => {
				this.checkDownState();
			}, 1000);
		}
	},
	computed: {
		downBg () {
			return function () {
				if (this.bgImg.value !== '') {
					return {
						background: `url(${this.bgImg.value}) 50% 100% no-repeat`,
						color: '#B20504'
					};
				} else {
					return {};
				}
			};
		}
	},
	methods: {
		// 获取游戏信息
		getGameInfo () {
			this.gameInfo = {};
			let url = 'https://apps.xinyue.qq.com/Dev/opt/get_pkg_msg';
			let postData = {
				androidPkgName: this.packagename
			};
			this.$axios.get(url, { params: postData }).then(res => {
				console.log(res);
				if (res.data.status === '200') {
					let data = res.data.msg;
					this.gameInfo.icon = data.icon[108] || data.icon[16];
					this.gameInfo.packagename = data.androidPkgName;
					this.gameInfo.version = data.version;
					this.gameInfo.gamename = data.gameName;
					this.gameInfo.channelid = data.channelNum;
					this.gameInfo.iosurl = data.IOSDownloadUrl;
					this.gameInfo.url = data.androidDownloadUrl;
					window.newkey = this.gameInfo.url;
					window.downloadAppCacheSed[window.newkey] =
            window.downloadAppCacheSed[window.newkey] || {};
				}
			});
		},
		// 判断机型
		userAgent () {
			// 判断手机
			let isAndroid = /linux|android/gi.test(navigator.userAgent.toLowerCase());
			let isiOS = /ipad|iphone|ipod/gi.test(navigator.userAgent.toLowerCase()); // ios终端
			if (isAndroid) {
				this.mobileType = 'android';
			} else if (isiOS) {
				this.mobileType = 'IOS';
			}
		},
		downBtn () {
			if (this.$actMode !== 'production') {
				return;
			}
			const [
				{
					h5Action: { type, value }
				}
			] = this.queryButton;
			if (type === 'link') {
				report('12025');
				window.location.href = value;
			} else {
				this.$miloLogin().then(LoginManager => {
					LoginManager.checkLogin(
						userInfo => {
							if (this.mobileType === 'android') {
								window.location.href = this.gameInfo.url;
							} else {
								window.location.href = this.gameInfo.iosurl;
							}
							let { channelid, version } = this.gameInfo;
							let downdata = {
								gchannelversion: channelid,
								packagename: this.packagename,
								dversion: version,
								apkchannel: ''
							};
							report('12015', downdata);
						},
						() => {
							alert('请先登录');
							report('12023');
						}
					);
				});
			}
		},
		async queryShow () {
			try {
				const [
					{
						h5Action: { type, value }
					}
				] = this.queryType;
				if (type === 'received') {
					const {
						res: { sOutValue1 }
					} = await this.$doAction('ame', value, {
						sServiceType: this.$actConfig.gameCode
					});
					if (sOutValue1 === '1') {
						this.show = true;
						document.getElementById('app').classList.add('showtype'); // 父元素判断所有白名单展示
					} else {
						this.show = false;
					}
				}
			} catch (e) {
				console.log(e);
			}
		}
	}
};
</script>
<style lang="scss" scoped>
@import "../../assets/scss/common";
.btnBoxFixed {
  position: fixed;
  bottom: 0;
  // left:0;
  z-index: 100;
}
.btnBox {
  height: 1.28rem;
  width: 7.5rem;
  background: #e27f7f;
}
.actModules_actionBtn {
  @extend %block;
  height: 1.28rem;
  width: 7.5rem;
  color: #ffffff;
  font-size: 0.4rem;
  @extend %box;
  /*! autoprefixer: off */
  -webkit-box-align: center;
  box-align: center;
  -webkit-box-pack: center;
  box-pack: center;
  -webkit-box-orient: vertical;
  box-orient: vertical;
  /* autoprefixer: on */
  //   @extend %fixed;
  left: 0;
  bottom: 0;
  margin: 0 auto;
}

.actModules_actionBtnTips {
  font-size: 0.26rem;
  color: #4a4a4a;
  @extend %block;
  line-height: 1.2;
}

.actModules_DownLoadBar {
  width: 1.6rem;
  @extend %inline-block;
  height: 0.3rem;
  vertical-align: middle;
  background: #4a4a4a;
  font-size: 0.24rem;
  font-style: normal;
  color: #fff;
  text-align: center;
  @extend %relative;
}

.actModules_DownLoadBarProcess {
  @extend %block;
  height: 100%;
  @extend %absolute;
  left: 0;
  top: 0;
  background: #e27f7f;
  border: 1px solid #4a4a4a;
}

.actModules_DownLoadPercent {
  @extend %relative;
  z-index: 10;
}
</style>



// WEBPACK FOOTER //
// src/components/actModules/h5/templates/bottomBtn/downBtn.vue